exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scoped-custom-list-group[data-v-7424eefc]{display:flex;flex-wrap:wrap;align-content:space-between;align-items:flex-start;width:100%;margin:0;padding:1rem 0}.scoped-custom-list-group .list-group-item[data-v-7424eefc]{width:98%;display:inline-block;margin:.5% 1%}@media (min-width:992px){.scoped-custom-list-group .list-group-item[data-v-7424eefc]{width:48%;display:inline-block}}.scoped-custom-list-group .list-group-item[data-v-7424eefc]:first-child,.scoped-custom-list-group .list-group-item[data-v-7424eefc]:last-child{border-radius:0}", ""]);

// exports
